export const doDownload = (path: string, name: string) => {
	const link = document.createElement('a');
	link.href = path;
	link.setAttribute('download', name);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};
